import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { requestOpportunityIdInformation } from 'services/entities/duck';

const SalesforceID = styled.span`
    font-size: 11px;
`;

const WorkOrderIdViewLink = ({
    workOrderId,
    adminPlatform,
    opportunityInfo,
    unicornUIBaseUrl,
    dispatch
}) => {
    if (adminPlatform !== 'salesforce') {
        return workOrderId;
    }

    useEffect(() => {
        if (!opportunityInfo) {
            dispatch(requestOpportunityIdInformation(workOrderId));
        }
    }, [workOrderId, opportunityInfo]);

    if (!opportunityInfo) {
        return workOrderId;
    }

    const {
        advertiser: { salesforceAccountId },
        salesforceOpportunityId,
        salesforceOpportunity: { name }
    } = opportunityInfo;

    const url = `${unicornUIBaseUrl}/advertisers/${salesforceAccountId}/opportunities/${salesforceOpportunityId}`;

    return <React.Fragment>
        <a href={url} target="_blank" title="Open Oppotunity">
            <span>{name}</span>
        </a>
        <br />
        <a href={url} target="_blank" title="Open Oppotunity">
            <SalesforceID>{`ID: ${workOrderId}`}</SalesforceID>
        </a>
    </React.Fragment>;
};

WorkOrderIdViewLink.propTypes = {
    opportunityInfo: PropTypes.object,
    unicornUIBaseUrl: PropTypes.string,
    workOrderId: PropTypes.string,
    adminPlatform: PropTypes.string,
};

const mapStateToProps = (state, props) => ({
    opportunityInfo: state.entities.opportunityIdInfo[props.workOrderId],
    unicornUIBaseUrl: state.config.unicornUIBaseUrl
});

export default connect(mapStateToProps)(WorkOrderIdViewLink);



// WEBPACK FOOTER //
// ./src/containers/entity/workOrder/WorkOrderIdViewLink.js